@if (isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div
  class="popup_main_div corres_popup_main select_metter_main_div"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
>
  <h2 cdkDragHandle mat-dialog-title class="title-withswitch">
    <span>{{ title }} Authority</span>
    <mat-slide-toggle (change)="ToggleForUpadte()">Show Template Fields</mat-slide-toggle>
    <button class="btn" mat-icon-button [mat-dialog-close]="false" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <div mat-dialog-content class="mat-typography">
    <!-- <div class="example-loading-shade" *ngIf="isLoadingResults">
  <mat-spinner [style.zoom]="1" *ngIf="isLoadingResults"></mat-spinner>
</div> -->
    <div class="one select_matter_main_div">
      <div class="center list_tbl_main more_tbl_clmn shrink-0">
        <div class="matter-serach-div sticky_search_div">
          <!-- select bar  -->
          <form
            name="SelectContact"
            id="SelectContact"
            fxLayout="column"
            fxLayoutAlign="start"
            fxFlex="1 0 auto"
            name="form"
          >
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
              <mat-form-field
                appearance="outline"
                fxFlex="33"
                class="pr-1"
                [ngClass]="{
                  'has-error': $safeNavigationMigration(errorWarningData.Error?.TOPICGUID),
                  'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TOPICGUID),
                }"
              >
                <mat-label>Topic</mat-label>
                <mat-select
                  (selectionChange)="TopicClassChange($event.value)"
                  [(ngModel)]="authorityDialoge.TOPICNAME"
                  name="TOPICNAME"
                  placeholder="Topic"
                >
                  @for (val of MainTopicClass; track val) {
                    <mat-option [value]="val.TOPICNAME">
                      {{ val.TOPICNAME }}
                    </mat-option>
                  }
                  <!-- <mat-option value="Environmental">Environmental</mat-option>
              <mat-option value="Limitations Peeriod">Limitations</mat-option>
              <mat-option value="Negligence">Negligence</mat-option>
              <mat-option value="Litigation">Litigation</mat-option> -->
                </mat-select>
                @if (testBool && toolTipList) {
                  <div
                    class="tooltip-wrap"
                    (click)="
                      tooltipService.copyTooltipText(
                        toolTipList
                          ? $safeNavigationMigration(toolTipList?.TOPICNAME?.COPYVALUE)
                          : ''
                      )
                    "
                  >
                    <input
                      id="myInput"
                      readonly
                      disabled
                      value="{{ toolTipList?.TOPICNAME?.COPYVALUE }}"
                    />
                    <mat-icon>file_copy</mat-icon>
                  </div>
                }
              </mat-form-field>

              <mat-form-field
                [ngClass]="{
                  'has-error': $safeNavigationMigration(errorWarningData.Error?.AUTHORITY),
                  'has-warning': $safeNavigationMigration(errorWarningData.Warning?.AUTHORITY),
                }"
                appearance="outline"
                fxFlex="34"
                class="pr-1"
              >
                <mat-label>Authority</mat-label>
                <input
                  [(ngModel)]="authorityDialoge.AUTHORITY"
                  name="AUTHORITY"
                  matInput
                  matTooltip="{{ toolTipList ? toolTipList.AUTHORITY?.HOVER : '' }}"
                  [matTooltipPosition]="toolTipPostion"
                />
                <!-- <mat-icon matSuffix class="secondary-text"></mat-icon> -->
                @if (testBool && toolTipList) {
                  <div
                    class="tooltip-wrap"
                    (click)="
                      tooltipService.copyTooltipText(
                        toolTipList
                          ? $safeNavigationMigration(toolTipList?.AUTHORITY?.COPYVALUE)
                          : ''
                      )
                    "
                  >
                    <input
                      id="myInput"
                      readonly
                      disabled
                      value="{{ toolTipList?.AUTHORITY?.COPYVALUE }}"
                    />
                    <mat-icon>file_copy</mat-icon>
                  </div>
                }
              </mat-form-field>

              <mat-form-field
                [ngClass]="{
                  'has-error': $safeNavigationMigration(errorWarningData.Error?.CITATION),
                  'has-warning': $safeNavigationMigration(errorWarningData.Warning?.CITATION),
                }"
                appearance="outline"
                fxFlex="33"
                class="pr-1"
              >
                <mat-label>Citation</mat-label>
                <input
                  [(ngModel)]="authorityDialoge.CITATION"
                  name="CITATION"
                  matInput
                  matTooltip="{{ toolTipList ? toolTipList.CITATION?.HOVER : '' }}"
                  [matTooltipPosition]="toolTipPostion"
                />
                <!-- <mat-icon matSuffix class="secondary-text"></mat-icon> -->
                @if (testBool && toolTipList) {
                  <div
                    class="tooltip-wrap"
                    (click)="
                      tooltipService.copyTooltipText(
                        toolTipList
                          ? $safeNavigationMigration(toolTipList?.CITATION?.COPYVALUE)
                          : ''
                      )
                    "
                  >
                    <input
                      id="myInput"
                      readonly
                      disabled
                      value="{{ toolTipList?.CITATION?.COPYVALUE }}"
                    />
                    <mat-icon>file_copy</mat-icon>
                  </div>
                }
              </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start start" fxFlex="1 0 auto">
              <mat-form-field
                class="website-field"
                [ngClass]="{
                  'has-error': $safeNavigationMigration(errorWarningData.Error?.WEBADDRESS),
                  'has-warning': $safeNavigationMigration(errorWarningData.Warning?.WEBADDRESS),
                }"
                appearance="outline"
                fxFlex="50"
                class="pr-1"
              >
                <mat-label>Authority Website</mat-label>
                <input
                  type="url"
                  pattern="https://.*"
                  [(ngModel)]="authorityDialoge.WEBADDRESS"
                  matTooltip="{{ toolTipList ? toolTipList.WEBADDRESS?.HOVER : '' }}"
                  [matTooltipPosition]="toolTipPostion"
                  name="WEBADDRESS"
                  matInput
                />
                @if (testBool && toolTipList) {
                  <div
                    class="tooltip-wrap"
                    (click)="
                      tooltipService.copyTooltipText(
                        toolTipList
                          ? $safeNavigationMigration(toolTipList?.WEBADDRESS?.COPYVALUE)
                          : ''
                      )
                    "
                  >
                    <input
                      id="myInput"
                      readonly
                      disabled
                      value="{{ toolTipList?.WEBADDRESS?.COPYVALUE }}"
                    />
                    <mat-icon>file_copy</mat-icon>
                  </div>
                }
              </mat-form-field>
              <!-- <mat-icon class="iconmargin" matSuffix (click)='openDocument()'>
            <img src="assets/icons/web_app/icon_letters_small_d.ico"  >
          </mat-icon> -->
              <mat-form-field
                [ngClass]="{
                  'has-error': $safeNavigationMigration(errorWarningData.Error?.REFERENCE),
                  'has-warning': $safeNavigationMigration(errorWarningData.Warning?.REFERENCE),
                }"
                appearance="outline"
                fxFlex="50"
                class="pr-1"
              >
                <mat-label>Reference</mat-label>
                <input
                  [(ngModel)]="authorityDialoge.REFERENCE"
                  name="REFERENCE"
                  matInput
                  matTooltip="{{ toolTipList ? toolTipList.REFERENCE?.HOVER : '' }}"
                  [matTooltipPosition]="toolTipPostion"
                />

                @if (testBool && toolTipList) {
                  <div
                    class="tooltip-wrap"
                    (click)="
                      tooltipService.copyTooltipText(
                        toolTipList
                          ? $safeNavigationMigration(toolTipList?.REFERENCE?.COPYVALUE)
                          : ''
                      )
                    "
                  >
                    <input
                      id="myInput"
                      readonly
                      disabled
                      value="{{ toolTipList?.REFERENCE?.COPYVALUE }}"
                    />
                    <mat-icon>file_copy</mat-icon>
                  </div>
                }
              </mat-form-field>
            </div>
            <!-- <div fxLayout="row" fxLayoutAlign="start start" fxFlex="1 0 auto">
        <mat-form-field
          [ngClass]="{'has-error':errorWarningData.Error?.COMMENT,'has-warning':errorWarningData.Warning?.COMMENT}"
          appearance="outline" fxFlex="100" class="pr-1">
          <mat-label>Comment</mat-label>
          <textarea [(ngModel)]="authorityDialoge.COMMENT_" name="COMMENT_" cdkTextareaAutosize
          cdkAutosizeMinRows="5" cdkAutosizeMaxRows="5" matInput matTooltip="{{(toolTipList)?toolTipList.COMMENT?.HOVER:''}}" [matTooltipPosition]="toolTipPostion"></textarea>
          <div  *ngIf="testBool && toolTipList" class="tooltip-wrap" (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.COMMENT?.COPYVALUE:'')"><input id="myInput"  readonly disabled value="{{toolTipList?.COMMENT?.COPYVALUE}}"><mat-icon >file_copy</mat-icon></div>
        </mat-form-field>

      </div> -->
            <div fxLayout="row" fxLayoutAlign="start stretch" fxFlex="1 0 auto">
              <mat-form-field
                appearance="outline"
                fxFlex="100"
                class="full-width pr-1"
                [ngClass]="{
                  'has-error': $safeNavigationMigration(errorWarningData.Error?.COMMENT),
                  'has-warning': $safeNavigationMigration(errorWarningData.Warning?.COMMENT),
                }"
              >
                <mat-label>Comment</mat-label>

                <textarea
                  matInput
                  [(ngModel)]="authorityDialoge.COMMENT_"
                  name="COMMENT_"
                  rows="4"
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="3"
                  cdkAutosizeMaxRows="10"
                  [matTooltip]="
                    toolTipList ? $safeNavigationMigration(toolTipList.COMMENT?.HOVER) : ''
                  "
                  [matTooltipPosition]="toolTipPostion"
                  (keydown.enter)="$event.stopImmediatePropagation()"
                ></textarea>
                @if (testBool && toolTipList) {
                  <div
                    class="tooltip-wrap"
                    (click)="
                      tooltipService.copyTooltipText(
                        $safeNavigationMigration(toolTipList?.COMMENT?.COPYVALUE)
                      )
                    "
                  >
                    <input
                      id="myInput"
                      readonly
                      disabled
                      [value]="$safeNavigationMigration(toolTipList?.COMMENT?.COPYVALUE)"
                    />
                    <mat-icon>file_copy</mat-icon>
                  </div>
                }
              </mat-form-field>
            </div>
          </form>
        </div>
      </div>
      <!-- <div class="example-containerdata">

            </div> -->
    </div>
  </div>

  <mat-dialog-actions class="popup_ftr contact_select_footer justify-end!">
    @if (action != 'edit') {
      <button
        mat-raised-button
        [disabled]="isspiner"
        (click)="SaveAuthority()"
        color="accent"
        class="h-[36px]"
      >
        @if (isspiner) {
          <mat-spinner
            style="
              zoom: 0.2;
              position: absolute;
              right: 0;
              left: 0;
              margin: auto;
              top: 0;
              bottom: 0;
            "
          ></mat-spinner>
        }
        Save
      </button>
    }
    @if (action == 'edit') {
      <button
        mat-raised-button
        [disabled]="isspiner"
        (click)="SaveAuthority()"
        color="accent"
        class="h-[36px]"
      >
        @if (isspiner) {
          <mat-spinner
            style="
              zoom: 0.2;
              position: absolute;
              right: 0;
              left: 0;
              margin: auto;
              top: 0;
              bottom: 0;
            "
          ></mat-spinner>
        }
        Update
      </button>
    }
    <button matButton="tonal" class="h-[36px]" [mat-dialog-close]="false" cdkFocusInitial>
      Don't Save
    </button>
  </mat-dialog-actions>
</div>
